<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card color="kbWhite" class="fill-height">
        <v-card-title class="font-weight-bold">
            {{cardLabel}}
            <v-spacer></v-spacer>
            <v-icon v-bind:color="upperRightIconColor">{{upperRightIcon}}</v-icon>
        </v-card-title>
        <v-card-text>
            <v-row class="ma-0"   >
                <v-col class="text-center" cols="12" >
                    <v-progress-circular v-bind:color="progressColor"
                                            :rotate="-90"
                                            :size="100"
                                            :width="15"
                                            :value="progressCount">
                        {{campaignTotal || 0}}
                    </v-progress-circular>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="pa-6">
            <v-row>
                {{`${campaignTypeLabel} ${cardLabel}`}}
                <v-spacer></v-spacer>
                {{campaignTotal}}&nbsp;<span class="grey--text" >({{progressCount || 0}}%)</span>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
  props: ['campaignTotal', 'progressCount', 'cardLabel', 'upperRightIcon', 'upperRightIconColor', 'progressColor', 'campaignTypeLabel']
}
</script>
